import {TextBody as Body} from './TextBody';
import {TextCaption as Caption} from './TextCaption';
import {TextHeading as Heading} from './TextHeading';
import {TextSubtitle as Subtitle} from './TextSubtitle';
import {TextHighlight as Highlight} from './TextHighlight';

export {Body, Caption, Heading, Subtitle, Highlight};
